import { FC, useMemo } from 'react'
import { AdvisorFloatPane, ADVISOR_FLOAT_PANE_TYPE } from 'components/features/coaching/advisorMeeting/types/floatPane'
import { AdvisorRequestTopic } from 'components/features/coaching/advisorMeeting/AdvisorRequestTopic/AdvisorRequestTopic'
import { AdvisorRequestSchedule } from 'components/features/coaching/advisorMeeting/AdvisorRequestSchedule/AdvisorRequestSchedule'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { AdvisorRequestLoading } from 'components/features/coaching/advisorMeeting/AdvisorRequestLoading/AdvisorRequestLoading'
import { AdvisorRequestConfirm } from 'components/features/coaching/advisorMeeting/AdvisorRequestConfirm/AdvisorRequestConfirm'
import { AdvisorRequestConfirmed } from 'components/features/coaching/advisorMeeting/AdvisorRequestConfirmed/AdvisorRequestConfirmed'
import { AdvisorRequestSubscription } from 'components/features/coaching/advisorMeeting/AdvisorRequestSubscription/AdvisorRequestSubscription'
import { AdvisorRequestSignup } from 'components/features/coaching/advisorMeeting/AdvisorRequestSignup/AdvisorRequestSignup'

export const TYPED_PANE = {
  type: ADVISOR_FLOAT_PANE_TYPE,
}

type AdvisorRequestPaneProps = {
  onClose: () => void
}
export const AdvisorRequestPane: FC<AdvisorRequestPaneProps> = (props) => {
  const { onClose } = props

  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, TYPED_PANE)) as Extract<AdvisorFloatPane, { mode: 'request' }> | null

  if (!pane) {
    return null
  }

  switch (pane.step) {
    case 'topic':
      return (
        <AdvisorRequestTopic onClose={ onClose } fields={ pane.fields } />
      )

    case 'search':
      return (
        <AdvisorRequestLoading onClose={ onClose } type={ pane.step } progressBarPercent={ 40 } />
      )

    case 'schedule':
      return (
        <AdvisorRequestSchedule onClose={ onClose } fields={ pane.fields } />
      )

    case 'confirm':
      return (
        <AdvisorRequestConfirm onClose={ onClose } fields={ pane.fields } />
      )

    case 'booking':
      return (
        <AdvisorRequestLoading onClose={ onClose } type={ pane.step } progressBarPercent={ 90 } />
      )

    case 'confirmed':
      return (
        <AdvisorRequestConfirmed onClose={ onClose } uid={ pane.uid } fields={ pane.fields } />
      )

    case 'subscription':
      return (
        <AdvisorRequestSubscription onClose={ onClose } fields={ pane.fields } />
      )

    case 'signup':
      return (
        <AdvisorRequestSignup onClose={ onClose } fields={ pane.fields } />
      )
  }

  return null
}
